import React, { useState, useEffect } from 'react';
import { Button, Table, PagingQuery } from 'tea-component';
import { useHistory, useIntl } from 'umi';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { tableDataFormatKMB } from '@/pages/intelligence/utils/commonUtils';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import { TopchartTableProps } from '@/pages/intelligence/pages/_config/topchartsInterface';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import {
  GenreHeader,
  GenreRender,
} from '@/pages/intelligence/components/TableComponents/components/TableGenre';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { RPDMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RPDCloums';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { DetailsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';
import { getGameRankDetails } from '@intelligence/utils/tableUtils';
import { formatReleaseTime } from '@home/components/NavHeader/sreachContext/utils';
import { getTagFilterColumns } from '@intelligence/v3/utils/sensorTowerTagColumns';
import { useIntl, getLocale } from 'umi';

interface RPDTableProps extends TopchartTableProps {
  asForDate: string;
  entityType?: string;
  fetchParams?: any;
  filterValue?: IRecord<any>;
  gameDetailsLoading?: boolean;
  gameDetailsMapping?: IRecord<IRecord>;
  onTagClick?: (type: string, tag: string) => void;
}

export default function RPDTable(props: RPDTableProps) {
  const {
    className,
    loading,
    records = [],
    tableTotal,
    pageSortAttr,
    asForDate,
    onTableSortChage,
    onTablePagingChange,
    tableSelection,
    tableSelectionAll,
    onTableCheckGame,
    entityType = '',
    fetchParams,
    filterValue,
    gameDetailsLoading = true,
    gameDetailsMapping = {},
    onTagClick,
  } = props;
  const { data_source } = fetchParams;

  const { locale, formatMessage } = useIntl();
  const intlLocale = getLocale();
  const { tablePageIndex, tablePageSize, currentSortValue, currentSortMetric } =
    pageSortAttr || {};
  const history = useHistory();
  const defaultPageSize = 100;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [selectList, setSelectList] = useState(tableSelection);
  const { rpdListTopchart } = useMobileOptionList({ asForDate });

  useEffect(() => {
    setSelectList(tableSelection);
  }, [tableSelection]);

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  const getDetailGamePath = (gameId: string) => {
    return getDetailGamePathCommon({
      entityType: 'mobile',
      gameId,
      tab: 'stats',
      subTab: 'rpd',
    });
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGamePath(gameId));
  };
  const getMetricValueOfCvm = (cvm: any, metricKey: string): string => {
    if (typeof cvm === 'object') {
      return tableDataFormatKMB(cvm[metricKey]).toString();
    }
    return '';
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    const titles = rpdListTopchart;

    titles.forEach((t) => {
      metricCloums.push(
        RPDMetricColumn(
          {
            width: t.width,
            width_cn: t?.width_cn ?? t.width,
            // dataSource: source, //source === 'ogdb' ? 'databarin' : source,
            title: t.title,
            textContent: t.textContent,
            key: `${t.key}`,
            sortMetric: t.key,
            metricKey: t?.metricKey || t?.key,
            currentSortValue,
            currentSortKey: `${currentSortMetric}`,
            onSortChage,
            getMetricValueOfCvm,
            entityType,
          },
          data_source[0],
        ),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <TopchartTable
        loading={loading}
        recordKey={'unifiedId'}
        records={Array.isArray(records) ? records : []}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        columns={[
          // { key: 'select', header: null, width: 37, fixed: 'left' },
          {
            key: 'select',
            width: 36,
            fixed: 'left',
            header: () => {
              return (
                <TableCheckboxHeader
                  selectList={selectList}
                  tableSelectionAll={tableSelectionAll}
                  disabled={loading || records.length === 0}
                  onChange={(list, stats) => {
                    onTableCheckGame(list, stats);
                    setSelectList(list);
                  }}
                />
              );
            },
            render: (cvm: any) => {
              return (
                <TableCheckboxRender
                  selectList={selectList}
                  cvm={{ ...(cvm || {}), gameId: cvm?.unifiedId }}
                  disabled={getGameRankDetails(cvm?.rank).isDisabled}
                  onChange={(list, status) => {
                    setSelectList(list);
                    onTableCheckGame(list, status);
                  }}
                />
              );
            },
          },
          {
            key: 'gametitle',
            header: (
              <div className="dbi-firstRow-flex">
                <div className="dbi-text-id">#</div>
                <div>{formatMessage({ id: 'dbi_top_gametitle' })}</div>
              </div>
            ),
            width: 330,
            fixed: 'left',
            render: (cvm: any) => (
              <FirstRow
                id={getGameRankDetails(cvm?.rank)?.rankText}
                cvm={{
                  img: cvm?.gameIcon,
                  gametitle: cvm?.gameName,
                  countryIcon: getCountryFlag(cvm?.gameMarketName),
                  text: cvm?.gameCompany,
                }}
                rihgtClickToJumpHref={getDetailGamePath(cvm?.unifiedId)}
                onClick={() => {
                  onClickGame(cvm.unifiedId);
                }}
              />
            ),
          },
          ...getMetricCloums(),
          {
            key: 'releaseDate',
            header: (
              <CloumsCenter width={140} align="left">
                <div className="header-other">
                  {formatMessage({ id: 'dbi_release_date' })}
                </div>
              </CloumsCenter>
            ),
            align: 'center',
            width: 140,
            render: (cvm: any) => {
              const releaseTime = formatReleaseTime(locale, {
                isSpecialReleaseTime: cvm?.isSpecialReleaseDate,
                releaseTime: cvm?.releaseDate,
                releaseTimeEN: cvm?.releaseDateEN,
                releaseTimeCN: cvm?.releaseDateCN,
              });
              return (
                <CloumsCenter width={140} align="left">
                  {releaseTime}
                </CloumsCenter>
              );
            },
          },
          {
            key: 'genre',
            header: (
              <div className="header-other">
                <GenreHeader />
              </div>
            ),
            align: 'left',
            width: 260,
            render: (cvm: any) => {
              return (
                <GenreRender
                  mainGenre={cvm?.mainGenre || '-'}
                  subGenre={cvm?.subgenre || '-'}
                />
              );
            },
          },
          ...getTagFilterColumns({
            filterValue,
            gameDetailsLoading,
            gameDetailsMapping,
            locale: intlLocale,
            formatMessage,
            onTagClick,
          }),
          DetailsCloums({
            onClickGame: (cvm: any) => {
              onClickGame(cvm?.unifiedId);
            },
            formatMessage,
          }),
        ]}
      />
    </>
  );
}
